import { render } from "./orderSuccess.vue?vue&type=template&id=175f7cee&scoped=true"
import script from "./orderSuccess.vue?vue&type=script&lang=js"
export * from "./orderSuccess.vue?vue&type=script&lang=js"

import "./orderSuccess.vue?vue&type=style&index=0&id=175f7cee&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175f7cee"]])

export default __exports__